import styled from 'styled-components';
import {device} from './responsives';

export const JourneyContainer= styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(auto, 1fr);
`

export const NoSelection = styled.h2`
  display: inline-block;
  font-family: Avenir;
  font-size: 32px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  margin-top: 24px;
  @media ${device.mobileL}{
    font-size: 16px;
    font-weight: 700;
  }
`

export const TitleContainer = styled.div`
  grid-column-start: 1;
  grid-column-end: 4;
  @media ${device.maxlaptop}{
    grid-column-start: 1;
    grid-column-end: 12;
    grid-row: auto;
  }
`

export const CardContainer = styled.div`
  grid-column-start: 4;
  grid-column-end: 12;
  margin-left: 20px;
  margin-top: 50px;
  @media ${device.maxlaptop}{
    grid-column-start: 1;
    grid-column-end: 13;
  }
`

export const FavCard = styled.div`
  @media ${device.minlaptop}{
    display: grid;
    grid-template-columns: 50% 50%;
    height: 316px;
    padding: 0px;
    box-shadow: 2px 4px 4px 1px rgba(0, 0, 0, 0.2);
    border: 1px solid #cacaca;
    border-radius: 8px;
    margin-top: 24px;
  }
  @media ${device.maxlaptop}{
    grid-template-columns: 100%;
    grid-template-rows: 40% 60%;
    margin-top: 16px;
    border: 1px solid #cacaca;
    border-radius: 8px;
  }
`

export const CardLeft = styled.div`
  @media ${device.minlaptop}{
    grid-column-start: 1;
    grid-column-end: 2;
    margin: 0px;
    position: relative;
    vertical-align: top;
  }
  @media ${device.maxlaptop}{
    grid-row-start: 1;
    grid-row-end: 2;
  }
`

export const Image = styled.img`
  width: calc(100%);
  height: 316px;
  object-fit: cover;
  border-radius: 8px 0px 0px 8px;
`

export const CardRight = styled.div`
  @media ${device.minlaptop}{
    grid-column-start: 2;
    grid-column-end: 3;
    padding-right: 16px;
    position: relative;
    vertical-align: top;
  }
  @media ${device.maxlaptop}{
    grid-row-start: 2;
    grid-row-end: 3;
    padding-right: 8px;
  }
`

export const Content = styled.div`
  height: 208px;
  width: calc(100%);
  overflow: hidden;
  padding-top: 39px;
  margin: 0px;
  position: relative;
  :after{
    content: "";
    text-align: right;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 30%;
    height: 1em;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, .7) 50%);
  }
`

export const BizTitle = styled.h3`
  color: #4a4a4a;
  overflow: hidden;
  font-family: Avenir-Heavy;
  font-size: 24px;
  margin: 0px 0px 8px 16px;
  line-height: 1.2;
  max-height: 52px;
  padding-bottom: 0px;
`

export const Description = styled.ul`
  list-style: none;
  line-height: normal;
  overflow: hidden;
  padding: 0px;
  margin: 0px 0px 0px 16px;
  font-family: Avenir-Roman;
  font-size: 16px;
  color: #4a4a4a;
`

export const DescLi = styled.li`
  ::before {
   content: "- "
  }
  margin-bottom: 19px;
  line-height: normal;
`

export const RemoveFavs = styled.button`
  background-color: clear;
  position: absolute;
  border: none;
  right: 16px;
  bottom: 16px;
  height: 48px;
  width: 48px;
  font-size: 14px
  font-family: Avenir-Roman;
  font-color: #4a4a4a;

  @media ${device.maxLaptop}{
    position: initial;
    margin-top: 8px;
    margin-bottom: 8px;
    margin-left: 90%;
  }

  @media ${device.mobileL}{
    position: initial;
    margin-top: 8px;
    margin-bottom: 8px;
    margin-left: 85%;
  }
  `

export const UnfavImg = styled.img`
  height: 90%;
  width: 100%;
  object-fit: cover;
`

export const Button = styled.button`
  position: absolute;
  bottom: 20px;
  right: 16px;
  font-size: 16px;
  padding: 6px 28px;
  border-radius: 2px;
  background-color: #d8d8d8;
  font-family: Avenir-Roman;
  height: 34px;
  @media ${device.maxlaptop}{
    display: inline-block;
    // bottom: 20px;
    left: 24px;

  }
`
